import { Button } from "@/components/ui/button";
import { ExternalLinkIcon } from "lucide-react";
import { Link } from "react-router-dom";

type AggregateOnlyEmptyStateProps = {
  caption: string;
  ctaLabel?: string;
  ctaHref?: string;
};

export function AggregateOnlyEmptyState({
  caption,
  ctaLabel,
  ctaHref,
}: AggregateOnlyEmptyStateProps): React.ReactElement {
  return (
    <div className="flex flex-col items-center justify-center text-center gap-4 py-12">
      <p className="text-sm text-muted-foreground max-w-sm">{caption}</p>
      {ctaLabel && ctaHref && (
        <Button asChild variant="outline">
          <Link to={ctaHref} target="_blank" rel="noopener noreferrer">
            {ctaLabel}
            <ExternalLinkIcon className="ml-2 w-4 h-4" />
          </Link>
        </Button>
      )}
    </div>
  );
}
